import { XStack, Button, SizableText } from '@my/ui'
import { ChevronLeft, X } from '@tamagui/lucide-icons'

type PostCreationHeaderProps = {
  onBack?: () => void
  onClose?: () => void
  title: string
  children?: React.ReactNode
}

export const PostCreationHeader = ({
  onClose,
  onBack,
  title,
  children
}: PostCreationHeaderProps) => {
  return (
    <XStack>
      <XStack ai="center" gap="$2">
        {onClose && (
          <Button
            ml="auto"
            aria-label="Close"
            plain
            size="$3"
            icon={<X size={24} />}
            px="$2"
            onPress={onClose}
          />
        )}
        {onBack && (
          <Button
            ml="auto"
            aria-label="Close"
            plain
            size="$3"
            icon={<ChevronLeft size={24} />}
            px="$2"
            onPress={onBack}
          />
        )}
        <SizableText
          size="$3"
          fow="500"
          $gtXs={{
            size: '$5',
            fow: '500'
          }}
        >
          {title}
        </SizableText>
      </XStack>
      {children && <XStack ml="auto">{children}</XStack>}
    </XStack>
  )
}
